/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Role_Code_TakenInputs */

const en_error_role_code_taken = /** @type {(inputs: Error_Role_Code_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another role already has this code.`)
};

/**
* | output |
* | --- |
* | "Another role already has this code." |
*
* @param {Error_Role_Code_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_role_code_taken = /** @type {((inputs?: Error_Role_Code_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Role_Code_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_role_code_taken(inputs)
});